import { useState } from 'react';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { camelCase } from '../Common/Util';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { MenuDropDown } from './Common/AppUtil';

export function BirthTimeCorrectionPageMenu({userData, handleMenu}) {
  const [showMenu, setShowMenu] = useState(false);
  const [menuArray, setMenuArray] = useState([true,false]);
  const [birthTimeCorrection, setBirthTimeCorrection] = useState(true);
  const [transitCuspalInInterval, setTransitCuspalInInterval] = useState(false);
  const [transitPlanetInInterval, setTransitPlanetInInterval] = useState(false);
  const setMethod = { setBirthTimeCorrection,setTransitCuspalInInterval,setTransitPlanetInInterval};
  const handleShowMenu = ()=>{setShowMenu(!showMenu);}

  const handleChange=(event)=>{
    for (let key in setMethod) {
      if (setMethod.hasOwnProperty(key)) {
        setMethod[key](false);
      }
    }
    const name = event.currentTarget.id;
    const methodName = "set"+camelCase(name);
    setMethod[methodName](event.currentTarget.checked);
    const tempMenuArray = [...menuArray];
    for(var i=0;i<menuArray.length;i++) {
       tempMenuArray[i]=false;
    }
    tempMenuArray[event.currentTarget.value]=event.currentTarget.checked;
    setMenuArray(tempMenuArray);
    handleMenu(tempMenuArray);
    setShowMenu(false);
  }

  handleMenu(menuArray);

  return (
    <>
    { userData===null || userData===undefined ?<></>:
      <div class="m-0 p-0 noprint" >
        <div class="row m-0 p-0">
          <div class="col-12 m-0 p-0">
            <Navbar expand="md" className="m-0 p-0 bg-light">
              <MenuDropDown title="Birth Time Correction" id={userData.id} runningId={userData.runningId}/>
              <Navbar.Toggle aria-controls="basic-navbar-nav" className="border-1 m-0 p-0 " onClick={()=>handleShowMenu()} />  
              <Navbar.Collapse id="basic-navbar-nav" className="m-0 p-0 "  in={showMenu} >
                <Nav className="m-0 p-0"  >
                  <div class="m-0 p-0">
                    <ToggleButton className="m-0 me-1 p-1 border-1" id="birthTimeCorrection" type="checkbox" variant="outline-transparent" checked={birthTimeCorrection} value="0" onChange={(e) => handleChange(e)}>Birth Time Correction</ToggleButton>
                    <ToggleButton className="m-0 me-1 p-1 border-1" id="transitCuspalInInterval" type="checkbox" variant="outline-transparent" checked={transitCuspalInInterval} value="1" onChange={(e) => handleChange(e)}>Cuspal In Interval</ToggleButton>
                    <ToggleButton className="m-0 me-1 p-1 border-1" id="transitPlanetInInterval" type="checkbox" variant="outline-transparent" checked={transitPlanetInInterval} value="2" onChange={(e) => handleChange(e)}>Planet In Interval</ToggleButton>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
      }
    </>
  );
}
